import React, { useState, useEffect } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';
import HomeComp from '../../components/Home/homeComp';
import HeaderComp from '../../components/Header/HeaderComp';
import SidebarComp from '../../components/Sidebar/SidebarComp';

function Home() {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    
    // Initialize state - start closed by default
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [hasInitialized, setHasInitialized] = useState(false);
    
    const toggleSidebar = () => {
        const newState = !sidebarOpen;
        setSidebarOpen(newState);
        // Save preference to localStorage (only on desktop)
        if (!isMobile) {
            localStorage.setItem('sidebarOpen', newState.toString());
        }
    };
    
    // Initialize sidebar state from localStorage and handle screen size changes
    useEffect(() => {
        if (isMobile) {
            // Always close on mobile
            setSidebarOpen(false);
        } else {
            // On desktop, restore saved preference
            if (!hasInitialized) {
                // First time: check localStorage
                const saved = localStorage.getItem('sidebarOpen');
                setSidebarOpen(saved === 'true');
                setHasInitialized(true);
            } else {
                // Subsequent changes: restore from localStorage
                const saved = localStorage.getItem('sidebarOpen');
                if (saved !== null) {
                    setSidebarOpen(saved === 'true');
                }
            }
        }
    }, [isMobile, hasInitialized]);
    
    return (
        <>
            <HeaderComp toggleSidebar={toggleSidebar} />
            <SidebarComp open={sidebarOpen} toggleSidebar={toggleSidebar} />
            <HomeComp />
        </>
    );
}

export default Home;
